import React from "react";
import Moment from "react-moment";
import moment from "moment";
import { DataFormats } from "utils/constants";

const FORMAT_RULES = [
  { test: /^\d{2}-\d{2}-\d{4}$/, format: "DD-MM-YYYY" },
  { test: /^\d{4}-\d{2}-\d{2}T/, format: "YYYY-MM-DDTHH:mm:ss.SSSZ" },
  { test: /^\d{4}-\d{2}-\d{2}-\d{2}-\d{2}-\d{2}-\d{3}$/, format: "YYYY-MM-DD-HH-mm-ss-SSS" },
  { test: /^\d{4}-\d{2}-\d{2}-\d{2}-\d{2}-\d{2}$/, format: "YYYY-MM-DD-HH-mm-ss" },
  { test: /^\d{4}-\d{2}-\d{2}$/, format: "YYYY-MM-DD" },
];

const detectFormat = (str) => FORMAT_RULES.find((r) => r.test.test(str))?.format;

const DateDisplay = ({
  value,
  format = DataFormats.DATE_FORMAT_SHORT,
}) => {
  if (value == null || value === "") return null;

  const strValue = String(value);
  const parseFormat = detectFormat(strValue);

  if (!parseFormat) return <>{strValue}</>;

  const parsed = moment(strValue, parseFormat, true);
  if (!parsed.isValid()) return <>{strValue}</>;

  return <Moment date={strValue} parse={parseFormat} format={format} trim />;
};

export default DateDisplay;